<template>
  <div>
    <header-title :title="$t('auth.forgotTitle')" />
    <div class="make-account-wrapper">
      <form>
        <div class="input-field">
          <label for="email">
            {{ $t('common.mail') }}
          </label>
          <input
            type="email"
            maxlength="128"
            class="form-control"
            v-model="email"
            v-validate="'email'"
            name="email"
          />
        </div>

        <p v-if="isDenied">{{ errorMsg }}</p>

        <next-button
          :label="$t('common.send')"
          @click.prevent="onSendMail"
          :disabled="!isDisabled"
          class="next-button"
        />
      </form>
    </div>
  </div>
</template>

<script>
import firebase from "firebase";
import HeaderTitle from '../design/HeaderTitleSlot'
import NextButton from '../components/atoms/NextButton'

export default {
  components: {
    HeaderTitle,
    NextButton
  },
  data() {
    return {
      isDenied: false,
      email: "",
      errorMsg: ""
    };
  },
  computed: {
    isDisabled: function() {
      return this.email && Object.keys(this.fields).some(key => this.fields[key].valid);
    }
  },
  methods: {
    async onSendMail() {
      try {
        const actionCodeSettings = {
          url: process.env.VUE_APP_SIGN_IN_LINK,
          handleCodeInApp: true
        };
        await firebase
          .auth()
          .sendPasswordResetEmail(this.email, actionCodeSettings);
        this.errorMsg = this.$t('auth.sendResetMail');
        this.isDenied = true;
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log("ERROR", error);
        this.errorMsg = this.$t('auth.failedMail');
        this.isDenied = true;
      }
    }
  }
};
</script>

<style scoped>
.make-account-wrapper {
  border: 2px solid #d7d7d7;
  border-radius: 10px;
  width: 100%;
  padding: 40px;
}
.form-control {
  border-radius: 5px;
  border: 1px solid #ced4da;
  padding: 5px;
  height: 30px;
  font-size: calc(100% + 0.25vw);
}
.input-field {
  display: grid;
  align-items: center;
  gap: 20px;
  margin-bottom: 40px;
  grid-template-columns: 1fr 4.5fr;
}
.justify-content-md-center {
  margin-top: 20px;
}
.next-button {
  margin-top: 20px;
}
/* エラー表記用 */
.invalid {
  border-color: red;
}
</style>
